import * as yup from "yup";
import { FilterDefinition } from "components/Shared/FilterEditor/utils";
import {
  getSelectFilterDefinition,
  getStringFilterDefinition,
} from "components/Shared/FilterEditor/standardFilters";
import { AddressFilter } from "__generated__/gql/graphql";
import { state } from "utils/schemas/address";
import USStateSelect from "components/Shared/Select/USStateSelect";
import { makeEnsureType } from "utils/typescriptUtilis";
import { assertIsString } from "utils/assertions";
import createNestedFilterDefinitions, {
  CreateNestedFilterDefinitionsOptions,
  getPrefixedId,
} from "components/Shared/FilterEditor/createNestedFilterDefinitions";

export const FULL_ADDRESS_FILTER_ID = "formatted";

const filterObj = makeEnsureType<AddressFilter>();

const filterDefinitions: FilterDefinition[] = [
  getStringFilterDefinition({
    id: FULL_ADDRESS_FILTER_ID,
    label: "Full Address",
    getResult: (value, { filterVariantDefinition: { id: variantId } }) => {
      assertIsString(value);
      return filterObj({ formatted: { [variantId]: value } });
    },
    schema: yup.string().min(2),
  }),
  getStringFilterDefinition({
    id: "city",
    label: "City",
    getResult: (value, { filterVariantDefinition: { id: variantId } }) => {
      assertIsString(value);
      return filterObj({ city: { [variantId]: value } });
    },
    schema: yup.string().min(2),
  }),
  getSelectFilterDefinition({
    id: "state",
    label: "State",
    getSelectResult: (value, { filterVariantDefinition: { id: variantId } }) =>
      filterObj({ state: { [variantId]: value } }),
    selectSchema: state,
    renderSelectInput: ({ field }, { isMulti }) => (
      <USStateSelect
        {...field}
        isMulti={isMulti}
        menuPortalTarget={document.body}
      />
    ),
  }),
  getStringFilterDefinition({
    id: "zip",
    label: "ZIP",
    getResult: (value, { filterVariantDefinition: { id: variantId } }) => {
      assertIsString(value);
      return filterObj({ zip: { [variantId]: value } });
    },
    schema: yup.string(),
  }),
];

export default filterDefinitions;

export function createNestedAddressFilterDefinitions(
  nestedKey = "address",
  options?: CreateNestedFilterDefinitionsOptions,
) {
  const { groupLabel = "Address" } = options || {};
  return createNestedFilterDefinitions(nestedKey, filterDefinitions, {
    getId: (fd) =>
      fd.id === FULL_ADDRESS_FILTER_ID
        ? nestedKey
        : getPrefixedId(nestedKey, fd.id),
    groupLabel,
    ...options,
  });
}
